import { render } from "./UiPropDynamicString.vue?vue&type=template&id=6cf79481"
import script from "./UiPropDynamicString.vue?vue&type=script&lang=js"
export * from "./UiPropDynamicString.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__